import type { TUseSubLogType } from './subLog'


import { useMemo } from 'react';
export function useStatusInfo({
  currentPlan,
}: {
  currentPlan: TUseSubLogType['currentPlan']
}) {
  const status = currentPlan?.status || ''
  /* 激活状态 */
  const isActive = status === 'active'
  /* 取消订阅 */
  const isCancel = status === 'canceled' || !!currentPlan?.cancelAtPeriodEnd
  /* 扣费失败 */
  const isPastDue = status === 'past_due'
  /* 暂停扣费 */
  const isPaused = status === 'paused'
  /* 试用 */
  const isCompleteTrial = status === 'trialing'
  /* 不完整的付款 */
  const isIncomplete = status === 'incomplete'
  /* 不完整的付款过期 */
  const isIncompleteExpired = status === 'incomplete_expired'
  /* 未付款 */
  const isUnpaid = status === 'unpaid'

  /* 能否进行购买加量包，修改支付方式等操作 */
  const canHandle = useMemo(() => {
    return isActive || isCompleteTrial
  }, [isActive, isCompleteTrial])

  return {
    isActive,
    isCancel,
    isPastDue,
    isPaused,
    isCompleteTrial,
    isIncomplete,
    isIncompleteExpired,
    isUnpaid,
    canHandle,
  }
}
